import { Fragment, useEffect, useState } from 'react';
import { DialogTitle, Transition } from '@headlessui/react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Modal from '../../../widgets/Modal';
import { supportMessage } from '../../../../shared/service/auth';

import ActiconHistory from '../../../../assets/icons/mfa/acticonHistory.svg?react';
import ActiconBell from '../../../../assets/icons/mfa/acticonBell.svg?react';
import ActiconDownload from '../../../../assets/icons/mfa/acticonDownload.svg?react';
import { useMfaModalContext } from '../../../../shared/providers/MfaModalProvider';

function NeedHelpModal({
  enabled,
  userData,
}: {
  enabled: boolean;
  userData: any;
}) {
  const [showToast, setShowToast] = useState(false);

  const { t } = useTranslation();

  const { setNeedHelpModal } = useMfaModalContext();

  useEffect(() => {
    setTimeout(() => {
      if (showToast) {
        setShowToast(false);
      }
    }, 3000);
  }, [showToast]);

  const uData = {
    name: userData?.name,
    message: 'REQUESTED FOR RESETING THEIR TWO-FACTOR AUTHENTICATION',
    token: userData?.token,
    action: 'MFA-SUPPORT',
  };

  const { mutate: refetchMfaSupportMessage } = useMutation({
    mutationKey: ['mfaSupportMessage'],
    mutationFn: () => supportMessage(uData),
    onSuccess: (response: any) => {
      if (response?.data?.data) {
        setShowToast(true);
      }
    },
  });

  return (
    <Modal
      open={enabled}
      closeButton
      handleClose={() => setNeedHelpModal(false)}
      modalClassName="w-full max-w-[500px]"
    >
      <div className="">
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('INSTRUCTIONS_HEADER')}
        </DialogTitle>
        <p className="text-black-600 mb-14 text-left text-xs">
          {t('INSTRUCTIONS_SUBHEADER')}
        </p>

        <ul className="max-w-md space-y-12 divide-gray-200 dark:divide-gray-700">
          <li>
            <div className="flex space-x-3">
              <div className="border-black-200 mt-[6px] h-fit shrink-0 rounded-[10px] border p-[15px] shadow-[0px_1px_2px_0px_#1018280D]">
                <ActiconHistory
                  className="w-[19.7px]"
                  fill="var(--color-black-700)"
                />
              </div>
              <div className="min-w-0 space-y-2">
                <p className="text-black-900 truncate font-medium">
                  {t('INSTRUCTIONS_STEP1_HEADER')}
                </p>
                <p className="text-black-600 truncate text-sm">
                  {t('INSTRUCTIONS_STEP1_SUBHEADER')}
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className="flex space-x-3">
              <div className="border-black-200 mt-[6px] h-fit shrink-0 rounded-[10px] border p-[15px] shadow-[0px_1px_2px_0px_#1018280D]">
                <ActiconDownload
                  className="w-[19.7px]"
                  fill="var(--color-black-700)"
                />
              </div>
              <div className="min-w-0 space-y-2">
                <p className="text-black-900 truncate font-medium">
                  {t('INSTRUCTIONS_STEP2_HEADER')}
                </p>
                <p className="text-black-600 truncate text-sm">
                  {t('INSTRUCTIONS_STEP2_SUBHEADER')}
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className="flex space-x-3">
              <div className="border-black-200 mt-[6px] h-fit shrink-0 rounded-[10px] border p-[15px] shadow-[0px_1px_2px_0px_#1018280D]">
                <ActiconBell
                  className="w-[19.7px]"
                  fill="var(--color-black-700)"
                />
              </div>
              <div className="min-w-0 space-y-2">
                <p className="text-black-900 truncate font-medium">
                  {t('INSTRUCTIONS_STEP3_HEADER')}
                </p>
                <p className="text-black-600 truncate text-sm">
                  {t('INSTRUCTIONS_STEP3_SUBHEADER')}
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div className="relative mt-40 mb-4 flex items-center justify-center gap-x-2">
          <span className="text-black-600 text-right text-xs">
            {t('MFA_NEED_HELP')}
          </span>

          <span
            className="text-primary-600 cursor-pointer text-xs font-semibold"
            onClick={() => {
              refetchMfaSupportMessage();
            }}
          >
            {t('CONTACT_SUPPORT')}
          </span>

          <Transition
            as={Fragment}
            show={showToast}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div className="intl-remove-br bg-black-800 absolute top-[-85px] right-0 left-0 m-auto flex w-fit justify-center rounded-[8px] px-4 py-[10px] text-[13px] text-white">
              {t('REQUEST_RECEIVED_BIOMETRIC')}
            </div>
          </Transition>
        </div>
      </div>
    </Modal>
  );
}

export default NeedHelpModal;
